module.exports = __webpack_public_path__ + "img/webedia.4611bf64.svg";